'use client'

import * as React from 'react'

import { cn } from '@/lib/utils'

interface SiteHeaderShellProps {
  children: React.ReactNode
}

export function SiteHeaderShell({ children }: SiteHeaderShellProps) {
  const [isScrolled, setIsScrolled] = React.useState(false)

  React.useEffect(() => {
    const updateHeaderBackground = () => {
      setIsScrolled(window.scrollY > 0)
    }

    updateHeaderBackground()
    window.addEventListener('scroll', updateHeaderBackground, { passive: true })

    return () => {
      window.removeEventListener('scroll', updateHeaderBackground)
    }
  }, [])

  return (
    <header
      className={cn(
        'sticky top-0 z-40 w-full border-b border-white/10 transition-all duration-300',
        isScrolled ? 'bg-black/40 backdrop-blur-xl' : 'bg-black',
      )}
    >
      {children}
    </header>
  )
}
